export default __webpack_public_path__ + "static/media/Usage.bad1803e.png";